/* jshint undef: true, unused: true */
/* globals require */

const convertLegacyDropdownOptions = require('../convertLegacyDropdownOptions');

const dosageUnits = convertLegacyDropdownOptions(require('./dropdown-options/medications__dosage-units'));
const formsAdministered = convertLegacyDropdownOptions(require('./dropdown-options/medications__forms-administered'));
const bnfClassifications = convertLegacyDropdownOptions(require('./dropdown-options/medications__bnf-classifications'));
const importantFactors = convertLegacyDropdownOptions(require('./dropdown-options/medications__important-factors'));
const routeAdministered = require('./dropdown-options/medications__route-administered');
const stageErrorOccurred = convertLegacyDropdownOptions(require('./dropdown-options/medications__stage-error-occurred'));
const typeOfError = convertLegacyDropdownOptions(require('./dropdown-options/medications__type-of-error'));
const adrActionTaken = convertLegacyDropdownOptions(require('./dropdown-options/medications__adr-action-taken'));
const adrOrganSystem = convertLegacyDropdownOptions(require('./dropdown-options/medications__adr-organ-system'));
const didDrugReactionReappear = convertLegacyDropdownOptions(require('./dropdown-options/medications__did-drug-reaction-reappear'));
const errorDetectedBy = convertLegacyDropdownOptions(require('./dropdown-options/medications__error-detected-by'));
const frequencyWrong = convertLegacyDropdownOptions(require('./dropdown-options/medications__frequency-wrong'));
const naranjoTotalScore = convertLegacyDropdownOptions(require('./dropdown-options/medications__naranjo-total-score'));
const drugReaction = convertLegacyDropdownOptions(require('./dropdown-options/medications__drug-reaction'));
const stillAdministered = require('./dropdown-options/medications__still-administered');
const yesNoUnknown = require('./dropdown-options/medications__yes-no-unknown');
const yesNoUnknownOptions = convertLegacyDropdownOptions(yesNoUnknown);
const actionTaken = require('./dropdown-options/medications__action_taken');
const actionTakenOptions = convertLegacyDropdownOptions(actionTaken);
const adrLessenedOptions = require('./dropdown-options/medications__adr_lessened');
const adrReappearedOptions = require('./dropdown-options/medications__adr_reappeared');

var getVisibleClientFields = require('./medications-visible-client-fields');

const objectPathToKey = require('../../../../js_functions/form-builder/js/objectPathToKey');
const productClient = require('../../../../js_functions/getProductClient')();

const mapProperties =function (chosenDrug, parentClass, administered)  {
  const prefix = administered ? 'administered' : 'intended';

  if (typeof chosenDrug !== 'undefined') {
    [
      'brand',
      'id',
      'manufacturer',
      'class',
      'type',
      'strength',
      'supplier',
      'sourceId'
    ].forEach(function (prop) {
      const pascalCasePropertyName = prop.replace(/^\w/, function (c) {
        return c.toUpperCase();
      });

      var structure = parentClass.settings.structure,
          key       = prefix + pascalCasePropertyName,
          propData  = (typeof chosenDrug[prop] === 'undefined') ? '' : chosenDrug[prop],
          foBuStructureObject;

      if (prop === 'id') {
        key = prefix + 'DrugId';
      }

      // This null check is required in case the spscFieldSet global is set
      // as not all fields will be available in this case (IQ-8793).
      const objectPath = objectPathToKey(structure, key);
      if(objectPath) {
        foBuStructureObject = objectPath.object;
        parentClass.updateField(foBuStructureObject, propData);
      }
    });
  }
};

module.exports = function formBuilderStructure (data = {}) {

  // Marks certain fields as optional.
  const optionalField = globals.isNewRecord && (productClient !== 'spsc' && productClient !== 'nswh');

  const structure = {
    columnTitleRow : {
      page         : 0,
      elementType  : 'multicolumn',
      wrapperClass : ['column-title-row', 'grid-row'],
      attributes   : {
        id : 'column-title-row'
      },
      inputChildren : {
        administeredColumn : {
          nonFormElement : true,
          elementType    : 'h4',
          wrapperClass   : 'col-6',
          attributes     : {
            id    : 'administered-duplicate-column',
            class : ['column-title', 'fobu__h4--alignleft'],
            html  : 'MEDICATIONS.V2.FORM.SUBHEADING.DRUG_ADMINISTERED'
          }
        },
        intendedColumn : {
          nonFormElement : true,
          elementType    : 'h4',
          wrapperClass   : 'col-6',
          attributes     : {
            id    : 'intended-column-title',
            class : ['column-title', 'fobu__h4--alignleft'],
            html  : 'MEDICATIONS.V2.FORM.SUBHEADING.DRUG_INTENDED'
          }
        }
      }
    },
    columnButtonRow : {
      page         : 0,
      elementType  : 'multicolumn',
      wrapperClass : ['column-top-row', 'grid-row'],
      attributes   : {
        id : 'column-button-row'
      },
      inputChildren : {
        administeredClearColumn : {
          elementType  : 'button',
          wrapperClass : 'col-3',
          onClick      : 'clearAdministeredFields',
          attributes   : {
            id    : 'administered-clear-column',
            class : ['dtx-button', 'dtx-button-small', 'button-clear'],
            html  : 'MEDICATIONS.V2.FORM.BUTTON.CLEAR',
            type: 'button'
          }
        },
        administeredDuplicateColumn : {
          elementType  : 'button',
          wrapperClass : 'col-3',
          onClick      : 'duplicateAdministeredFields',
          attributes   : {
            id    : 'administered-column-title',
            class : ['dtx-button', 'dtx-button-small', 'button-tertiary'],
            html  : 'MEDICATIONS.V2.FORM.BUTTON.DUPLICATE',
            type: 'button'
          }
        },
        intendedClearColumn : {
          elementType  : 'button',
          wrapperClass : 'col-3',
          onClick      : 'clearIntendedFields',
          attributes   : {
            id    : 'intended-clear-column',
            class : ['dtx-button', 'dtx-button-small', 'button-clear'],
            html  : 'MEDICATIONS.V2.FORM.BUTTON.CLEAR',
            type: 'button'
          }
        }
      }
    },
    drugRow : {
      page         : 0,
      elementType  : 'multicolumn',
      wrapperClass : 'grid-row',
      attributes   : {
        id : 'drug-row'
      },
      inputChildren : {
        administeredDrug : {
          // elementType : 'input, // defaults to input
          elementType       : 'inputwithbutton',
          page              : 0,
          label             : 'MEDICATIONS.V2.FORM.LABEL.SEARCH_DRUG_ADMINISTERED',
          wrapperClass      : 'col-6',
          comboWrapperClass : 'col--no-margin',
          labelClass        : 'col--no-margin',
          attributes   : {
            name         : 'administeredDrug',
            required     : 'required',
            class        : 'INC-medications__administered-field'
          },
          dataObjectNameKey : 'drug',
          inputWithButtonProps      : {
            initScript : data.initInputWithButton,
            addOn:
            {
              class:'search-icon',
            },
            emptyResult : {
              message: 'MEDICATIONS.V2.FORM.MESSAGES.SEARCH_ADMINISTERED_NO_MATCHES_FOUND'
            },
          },

          validation : {
            required  : true
          },
          onUpdateDependentValues : function (chosenDrug, parentClass) {
            mapProperties(chosenDrug, parentClass, true);
          }
        },
        intendedDrug : {
          // elementType : 'input, // defaults to input
          elementType       : 'inputwithbutton',
          page              : 1,
          label             : 'MEDICATIONS.V2.FORM.LABEL.SEARCH_DRUG_INTENDED',
          wrapperClass      : 'col-6',
          comboWrapperClass : 'col--no-margin',
          labelClass        : 'col--no-margin',
          attributes   : {
            name         : 'intendedDrug',
            required     : 'required',
            class        : 'INC-medications__intended-field'
          },
          dataObjectNameKey : 'drug',
          inputWithButtonProps      : {
            initScript : data.initInputWithButton,
            addOn:
            {
              class:'search-icon',
            },
            emptyResult : {
              message: 'MEDICATIONS.V2.FORM.MESSAGES.SEARCH_DRUG_INTENDED_NO_MATCHES_FOUND'
            },
          },
          validation : {
            required  : true
          },

          onUpdateDependentValues : function (chosenDrug, parentClass) {
            mapProperties(chosenDrug, parentClass, false);
          }
        }
      }
    },
    administeredDrugId : {
      page        : 0,
      elementType : 'hidden',
      attributes  : {
        name         : 'administeredDrugId',
        class        : 'INC-medications__administered-field',
        required     : 'required',
      },
      populatedBy : 'administeredDrug',
      validation  : {
        required : true
      }
    },
    intendedDrugId : {
      page        : 0,
      elementType : 'hidden',
      attributes  : {
        name         : 'intendedDrugId',
        class        : 'INC-medications__intended-field',
        required     : 'required',
      },
      populatedBy : 'intendedDrug',
      validation  : {
        required : true
      }
    },
    brandRow : {
      page         : 0,
      elementType  : 'multicolumn',
      wrapperClass : 'grid-row',
      attributes   : {
        id : 'brand-row'
      },
      inputChildren : {
        administeredBrand : {
          label        : 'MEDICATIONS.V2.FORM.LABEL.SEARCH_DRUG_ADMINISTERED_BRAND',
          wrapperClass : 'col-6',
          labelClass   :  'col--no-margin',
          attributes   : {
            name     : 'administeredBrand',
            disabled : 'disabled',
            class    : 'INC-medications__administered-field'
          },
          populatedBy : 'administeredDrug'
        },
        intendedBrand : {
          label        : 'MEDICATIONS.V2.FORM.LABEL.SEARCH_DRUG_INTENDED_BRAND',
          wrapperClass : 'col-6',
          labelClass   :  'col--no-margin',
          attributes   : {
            name     : 'intendedBrand',
            disabled : 'disabled',
            class    : 'INC-medications__intended-field'
          },
          populatedBy : 'intendedDrug'
        }
      }
    },
    manufacturerRow : {
      page         : 0,
      elementType  : 'multicolumn',
      wrapperClass : 'grid-row',
      attributes   : {
        id : 'manufacturer-row'
      },
      inputChildren : {
        administeredManufacturer : {
          label        : 'MEDICATIONS.V2.FORM.LABEL.DRUG_ADMINISTERED_MANUFACTURER',
          wrapperClass : 'col-6',
          labelClass   :  'col--no-margin',
          attributes   : {
            name     : 'administeredManufacturer',
            disabled : 'disabled',
            class    : 'INC-medications__administered-field'
          },
          populatedBy : 'administeredDrug'
        },
        intendedManufacturer : {
          label        : 'MEDICATIONS.V2.FORM.LABEL.DRUG_INTENDED_MANUFACTURER',
          wrapperClass : 'col-6',
          labelClass   :  'col--no-margin',
          attributes   : {
            name     : 'intendedManufacturer',
            disabled : 'disabled',
            class    : 'INC-medications__intended-field'
          },
          populatedBy : 'intendedDrug'
        },
      }
    },
    classRow : {
      page         : 0,
      elementType  : 'multicolumn',
      wrapperClass : 'grid-row',
      attributes   : {
        id : 'class-row'
      },
      inputChildren : {
        administeredClass : {
          label        : 'MEDICATIONS.V2.FORM.LABEL.DRUG_ADMINISTERED_CLASS',
          wrapperClass : 'col-6',
          labelClass   :  'col--no-margin',
          attributes   : {
            name     : 'administeredClass',
            disabled : 'disabled',
            class    : 'INC-medications__administered-field'
          },
          populatedBy : 'administeredDrug'
        },
        intendedClass : {
          label        : 'MEDICATIONS.V2.FORM.LABEL.DRUG_INTENDED_CLASS',
          wrapperClass : 'col-6',
          labelClass   :  'col--no-margin',
          attributes   : {
            name     : 'intendedClass',
            disabled : 'disabled',
            class    : 'INC-medications__intended-field'
          },
          populatedBy : 'intendedDrug'
        },
      }
    },
    strengthRow : {
      page         : 0,
      elementType  : 'multicolumn',
      wrapperClass : 'grid-row',
      attributes   : {
        id : 'class-row'
      },
      inputChildren : {
        administeredStrength : {
          label        : 'MEDICATIONS.V2.FORM.LABEL.DRUG_ADMINISTERED_STRENGTH',
          wrapperClass : ['col-6', 'col--no-padding'],
          labelClass   :  'col--no-margin',
          attributes   : {
            name     : 'administeredStrength',
            disabled : 'disabled',
            class    : 'INC-medications__administered-field'
          },
          populatedBy : 'administeredDrug'
        },
        intendedStrength : {
          label        : 'MEDICATIONS.V2.FORM.LABEL.DRUG_INTENDED_STRENGTH',
          wrapperClass : ['col-6', 'col--no-padding'],
          labelClass   :  'col--no-margin',
          attributes   : {
            name     : 'intendedStrength',
            disabled : 'disabled',
            class    : 'INC-medications__intended-field'
          },
          populatedBy : 'intendedDrug'
        },
      }
    },
    supplierRow : {
      page         : 0,
      elementType  : 'multicolumn',
      wrapperClass : 'grid-row',
      attributes   : {
        id : 'class-row'
      },
      inputChildren : {
        administeredSupplier : {
          label        : 'MEDICATIONS.V2.FORM.LABEL.DRUG_ADMINISTERED_SUPPLIER',
          wrapperClass : ['col-6', 'col--no-padding'],
          labelClass   :  'col--no-margin',
          attributes   : {
            name     : 'administeredSupplier',
            disabled : 'disabled',
            class    : 'INC-medications__administered-field'
          },
          populatedBy : 'administeredDrug'
        },
        intendedSupplier : {
          label        : 'MEDICATIONS.V2.FORM.LABEL.DRUG_INTENDED_SUPPLIER',
          wrapperClass : ['col-6', 'col--no-padding'],
          labelClass   :  'col--no-margin',
          attributes   : {
            name     : 'intendedSupplier',
            disabled : 'disabled',
            class    : 'INC-medications__intended-field'
          },
          populatedBy : 'intendedDrug'
        },
      }
    },
    typeRow : {
      page         : 0,
      elementType  : 'multicolumn',
      wrapperClass : 'grid-row',
      attributes   : {
        id : 'type-row'
      },
      inputChildren : {
        administeredType : {
          label        : 'MEDICATIONS.V2.FORM.LABEL.DRUG_ADMINISTERED_TYPE',
          wrapperClass : 'col-6',
          labelClass   :  'col--no-margin',
          attributes   : {
            name     : 'administeredType',
            disabled : 'disabled',
            class    : 'INC-medications__administered-field'
          },
          populatedBy : 'administeredDrug'
        },
        intendedType : {
          label        : 'MEDICATIONS.V2.FORM.LABEL.DRUG_INTENDED_TYPE',
          wrapperClass : 'col-6',
          labelClass   :  'col--no-margin',
          attributes   : {
            name     : 'intendedType',
            disabled : 'disabled',
            class    : 'INC-medications__intended-field'
          },
          populatedBy : 'intendedDrug'
        },
      }
    },
    sourceIdRow : {
      globalSwitch : 'vanessasLawEnabled',
      page         : 0,
      elementType  : 'multicolumn',
      wrapperClass : 'grid-row',
      attributes   : {
        id : 'source-id-row'
      },
      inputChildren : {
        administeredSourceId : {
          label        : 'MEDICATIONS.V2.FORM.LABEL.DRUG_ADMINISTERED_SOURCE_ID',
          wrapperClass : 'col-6',
          labelClass   :  'col--no-margin',
          attributes   : {
            name     : 'administeredSourceId',
            disabled : 'disabled',
            class    : 'INC-medications__administered-field'
          },
          populatedBy : 'administeredDrug'
        },
        intendedSourceId : {
          label        : 'MEDICATIONS.V2.FORM.LABEL.DRUG_INTENDED_SOURCE_ID',
          wrapperClass : 'col-6',
          labelClass   :  'col--no-margin',
          attributes   : {
            name     : 'intendedSourceId',
            disabled : 'disabled',
            class    : 'INC-medications__intended-field'
          },
          populatedBy : 'intendedDrug'
        },
      }
    },
    routeRow : {
      page         : 0,
      elementType  : 'multicolumn',
      labelFor     : 'administeredAdministrationRoute',
      wrapperClass : 'grid-row',
      attributes   : {
        id : 'drug-row'
      },
      inputChildren : {
        administeredAdministrationRoute : {
          page              : 0,
          label             : 'MEDICATIONS.V2.FORM.LABEL.DRUG_ADMINISTERED_ROUTE',
          wrapperClass      : 'col-6',
          comboWrapperClass : 'col--no-margin',
          labelClass        : 'col--no-margin',
          attributes        : {
            name        : 'administeredAdministrationRoute',
            placeholder : 'MEDICATIONS.V2.FORM.PLACEHOLDER.DRUG_ADMINISTERED_ROUTE_SELECT_ONE',
            class       : 'INC-medications__administered-field'
          },
          elementType : 'typeahead',
          options     : routeAdministered,
          validation  : {
            required : !optionalField
          },
          useLegacyDropDownComponent:true

        },
        intendedAdministrationRoute : {
          page              : 0,
          label             : 'MEDICATIONS.V2.FORM.LABEL.DRUG_INTENDED_ROUTE',
          wrapperClass      : 'col-6',
          comboWrapperClass : 'col--no-margin',
          labelClass        : 'col--no-margin',
          attributes        : {
            name        : 'intendedAdministrationRoute',
            placeholder : 'MEDICATIONS.V2.FORM.PLACEHOLDER.DRUG_INTENDED_ROUTE_SELECT_ONE',
            class       : 'INC-medications__intended-field'
          },
          elementType : 'typeahead',
          options     : routeAdministered,
          validation  : {
            required : !optionalField
          },
          useLegacyDropDownComponent:true
        },
      }
    },
    doseRow : {
      page         : 0,
      elementType  : 'multicolumn',
      labelFor     : 'administeredAdministrationDosage',
      wrapperClass : 'grid-row',
      attributes   : {
        id : 'dose-row'
      },
      inputChildren : {
        administeredAdministrationDosage : {
          page         : 0,
          elementType  : 'combo',
          label        : 'MEDICATIONS.V2.FORM.LABEL.DRUG_ADMINISTERED_DOSAGE',
          wrapperClass : 'col-6',
          labelClass   :  ['col-12', 'col--no-margin'],
          attributes   : (() => {
            const obj = {
              name  : 'administeredAdministrationDosage',
              class : 'form-control',
            };
            if (!optionalField) {
              obj.required = 'required';
            }
            return obj;
          })(),
          validation : {
            required  : !optionalField,
            combo : optionalField ? [] : ['administeredAdministrationDosageValue', 'administeredAdministrationDosageUnit']

          },
          messages : {
            required : 'MEDICATIONS.V2.FORM.MESSAGE.DRUG_ADMINISTERED_DOSAGE_UNIT'
          },
          inputChildren : {
            administeredAdministrationDosageValue : {
              comboParent      : 'administeredAdministrationDosage',
              inputLayoutClass : ['col-6', 'col--no-margin'],
              attributes       : {
                type  : 'number',
                min   : 0,
                name  : 'administeredAdministrationDosageValue',
                class : 'INC-medications__administered-field'
              }
            },
            administeredAdministrationDosageUnit : {
              comboParent      : 'administeredAdministrationDosage',
              inputLayoutClass : ['col-6', 'col--no-margin'],
              elementType      : 'typeahead',
              attributes       : {
                name        : 'administeredAdministrationDosageUnit',
                placeholder : 'MEDICATIONS.V2.FORM.PLACEHOLDER.DRUG_ADMINISTERED_UNITS',
                class       : 'INC-medications__administered-field'
              },
              options : dosageUnits,
              useLegacyDropDownComponent:true
            }
          }
        },
        intendedAdministrationDosage : {
          page         : 1,
          elementType  : 'combo',
          label        : 'MEDICATIONS.V2.FORM.LABEL.DRUG_INTENDED_DOSAGE',
          wrapperClass : 'col-6',
          labelClass   :  ['col-12', 'col--no-margin'],
          attributes   : (() => {
            const obj = {
              name : 'intendedAdministrationDosage',
            };
            if (!optionalField) {
              obj.required = 'required';
            }
            return obj;
          })(),
          validation : {
            required  : !optionalField,
            combo : optionalField ? [] : ['intendedAdministrationDosageValue', 'intendedAdministrationDosageUnit']

          },
          messages : {
            required : 'MEDICATIONS.V2.FORM.MESSAGE.DRUG_INTENDED_DOSAGE_UNIT'
          },
          inputChildren : {
            intendedAdministrationDosageValue : {
              comboParent      : 'intendedAdministrationDosage',
              inputLayoutClass : ['col-6', 'col--no-margin'],
              attributes       : {
                type  : 'number',
                min   : 0,
                name  : 'intendedAdministrationDosageValue',
                class : 'INC-medications__intended-field'
              }
            },
            intendedAdministrationDosageUnit : {
              comboParent      : 'intendedAdministrationDosage',
              elementType      : 'typeahead',
              inputLayoutClass : ['col-6', 'col--no-margin'],
              attributes       : {
                name        : 'intendedAdministrationDosageUnit',
                placeholder : 'MEDICATIONS.V2.FORM.PLACEHOLDER.DRUG_INTENDED_UNITS',
                class       : 'INC-medications__intended-field'
              },
              options : dosageUnits,
              useLegacyDropDownComponent:true
            }
          }
        }
      }
    },
    formRow : {
      page         : 0,
      elementType  : 'multicolumn',
      labelFor     : 'administeredAdministrationForm',
      wrapperClass : 'grid-row',
      attributes   : {
        id : 'form-row'
      },
      inputChildren : {
        administeredFormAdministered : {
          page              : 0,
          elementType       : 'typeahead',
          label             : 'MEDICATIONS.V2.FORM.LABEL.FORM_ADMINISTERED',
          wrapperClass      : 'col-6',
          comboWrapperClass : 'col--no-margin',
          labelClass        : 'col--no-margin',
          attributes        : {
            name        : 'administeredFormAdministered',
            placeholder : 'MEDICATIONS.V2.FORM.PLACEHOLDER.FORM_ADMINISTERED_SELECT_ONE',
            class       : 'INC-medications__administered-field'
          },
          options    : formsAdministered,
          validation : {
            required : !optionalField
          },
          useLegacyDropDownComponent:true
        },
        intendedFormAdministered : {
          page              : 1,
          elementType       : 'typeahead',
          label             : 'MEDICATIONS.V2.FORM.LABEL.FORM_INTENDED',
          wrapperClass      : 'col-6',
          comboWrapperClass : 'col--no-margin',
          labelClass        : 'col--no-margin',
          attributes        : {
            name        : 'intendedFormAdministered',
            placeholder : 'MEDICATIONS.V2.FORM.PLACEHOLDER.FORM_INTENDED_SELECT_ONE',
            class       : 'INC-medications__intended-field'
          },
          options    : formsAdministered,
          validation : {
            required : !optionalField
          },
          useLegacyDropDownComponent:true
        }
      }
    },
    reportToManufacturerRow : {
      globalSwitch : 'vanessasLawEnabled',
      page         : 0,
      elementType  : 'multicolumn',
      labelFor     : 'administeredAdministrationForm',
      wrapperClass : 'grid-row',
      attributes   : {
        id : 'form-row'
      },
      inputChildren : {
        reportedToManufacturer : {
          page              : 0,
          elementType       : 'typeahead',
          label             : 'MEDICATIONS.V2.FORM.LABEL.REPORTED_TO_MANUFACTURER',
          wrapperClass      : 'col-6',
          comboWrapperClass : 'col--no-margin',
          labelClass        : 'col--no-margin',
          attributes        : {
            name        : 'reportedToManufacturer',
            placeholder : 'MEDICATIONS.V2.FORM.PLACEHOLDER.FORM_ADMINISTERED_SELECT_ONE',
            class       : 'INC-medications__administered-field'
          },
          options    : yesNoUnknownOptions,
          validation : {
            required : !optionalField
          },
          useLegacyDropDownComponent:true
        }
      }
    },
    dateReportedToManufacturer : {
      globalSwitch : 'vanessasLawEnabled',
      page         : 0,
      elementType  : 'multicolumn',
      labelFor     : 'administeredAdministrationForm',
      wrapperClass : 'grid-row',
      attributes   : {
        id : 'form-row'
      },
      inputChildren : {
        dateReportedToManufacturer : {
          page              : 0,
          elementType       : 'date',
          label             : 'MEDICATIONS.V2.FORM.LABEL.DATE_REPORTED_TO_MANUFACTURER',
          wrapperClass      : 'col-6',
          attributes        : {
            name        : 'dateReportedToManufacturer',
            class       : 'INC-medications__administered-field'
          },
          validation : {
            required : !optionalField
          },
          dateFormat : () => globals.dateFormat,
          useLegacyDropDownComponent: true,
          visibleCondition: {
            fieldName: 'reportedToManufacturer',
            values: [yesNoUnknown.yes]
          }
        }
      }
    },
    manufacturerRef : {
      globalSwitch : 'vanessasLawEnabled',
      page         : 0,
      elementType  : 'multicolumn',
      labelFor     : 'administeredAdministrationForm',
      wrapperClass : 'grid-row',
      attributes   : {
        id : 'form-row'
      },
      inputChildren : {
        manufacturerRef : {
          page              : 0,
          label             : 'MEDICATIONS.V2.FORM.LABEL.MANUFACTURER_REF',
          wrapperClass      : 'col-6',
          comboWrapperClass : 'col--no-margin',
          labelClass        : 'col--no-margin',
          attributes        : {
            name        : 'manufacturerRef',
            class       : 'INC-medications__administered-field'
          },
          validation : {
            required : !optionalField
          },
          useLegacyDropDownComponent: true,
          visibleCondition: {
            fieldName: 'reportedToManufacturer',
            values: [yesNoUnknown.yes]
          }
        }
      }
    },
    isStillAdministered : {
      globalSwitch : 'vanessasLawEnabled',
      page         : 0,
      elementType  : 'multicolumn',
      labelFor     : 'administeredAdministrationForm',
      wrapperClass : 'grid-row',
      attributes   : {
        id : 'form-row'
      },
      inputChildren : {
        isStillAdministered : {
          page              : 0,
          elementType       : 'typeahead',
          label             : 'MEDICATIONS.V2.FORM.LABEL.STILL_ADMINISTERED',
          wrapperClass      : 'col-6',
          comboWrapperClass : 'col--no-margin',
          labelClass        : 'col--no-margin',
          attributes        : {
            name        : 'isStillAdministered',
            placeholder : 'MEDICATIONS.V2.FORM.PLACEHOLDER.FORM_ADMINISTERED_SELECT_ONE',
            class       : 'INC-medications__administered-field'
          },
          options    : stillAdministered,
          validation : {
            required : !optionalField
          },
          useLegacyDropDownComponent:true
        }
      }
    },
    frequency: {
      globalSwitch: 'vanessasLawEnabled',
      page: 0,
      elementType: 'multicolumn',
      labelFor: 'administeredAdministrationForm',
      wrapperClass: 'grid-row',
      attributes: {
        id: 'form-row'
      },
      inputChildren: {
        manufacturerRef: {
          page: 0,
          label: 'MEDICATIONS.V2.FORM.LABEL.FREQUENCY',
          wrapperClass: 'col-6',
          comboWrapperClass: 'col--no-margin',
          labelClass: 'col--no-margin',
          attributes: {
            name: 'frequency',
            class: 'INC-medications__administered-field'
          },
          useLegacyDropDownComponent: true,
        }
      }
    },
    productExpiryDate: {
      globalSwitch: 'vanessasLawEnabled',
      page: 0,
      elementType: 'multicolumn',
      labelFor: 'administeredAdministrationForm',
      wrapperClass: 'grid-row',
      attributes: {
        id: 'form-row'
      },
      inputChildren: {
        productExpiryDate: {
          page: 0,
          elementType: 'date',
          label: 'MEDICATIONS.V2.FORM.LABEL.PRODUCT_EXPIRY_DATE',
          wrapperClass: 'col-6',
          attributes: {
            name: 'productExpiryDate',
            class: 'INC-medications__administered-field'
          },
          dateFormat: () => globals.dateFormat,
        }
      }
    },
    actionTaken: {
      globalSwitch: 'vanessasLawEnabled',
      page: 0,
      elementType: 'multicolumn',
      labelFor: 'administeredAdministrationForm',
      wrapperClass: 'grid-row',
      attributes: {
        id: 'form-row'
      },
      inputChildren: {
        actionTaken: {
          page: 0,
          elementType: 'typeahead',
          label: 'MEDICATIONS.V2.FORM.LABEL.ACTION_TAKEN',
          wrapperClass: 'col-6',
          comboWrapperClass: 'col--no-margin',
          labelClass: 'col--no-margin',
          attributes: {
            name: 'actionTaken',
            placeholder: 'MEDICATIONS.V2.FORM.PLACEHOLDER.FORM_ADMINISTERED_SELECT_ONE',
            class: 'INC-medications__administered-field'
          },
          options: actionTakenOptions,
          useLegacyDropDownComponent:true
        }
      }
    },
    adrLessened: {
      globalSwitch: 'vanessasLawEnabled',
      page: 0,
      elementType: 'multicolumn',
      labelFor: 'administeredAdministrationForm',
      wrapperClass: 'grid-row',
      attributes: {
        id: 'form-row',
      },
      inputChildren: {
        adrLessened: {
          page: 0,
          elementType: 'typeahead',
          label: 'MEDICATIONS.V2.FORM.LABEL.ADR_LESSENED',
          wrapperClass: 'col-6',
          comboWrapperClass: 'col--no-margin',
          labelClass: 'col--no-margin',
          attributes: {
            name: 'adrLessened',
            placeholder: 'MEDICATIONS.V2.FORM.PLACEHOLDER.FORM_ADMINISTERED_SELECT_ONE',
            class: 'INC-medications__administered-field',
          },
          options: adrLessenedOptions,
          useLegacyDropDownComponent:true,
          visibleCondition: {
            fieldName: 'actionTaken',
            values: [actionTaken.withdrawn, actionTaken.dose_reduced],
          },
        }
      }
    },
    adrReappeared: {
      globalSwitch: 'vanessasLawEnabled',
      page: 0,
      elementType: 'multicolumn',
      labelFor: 'administeredAdministrationForm',
      wrapperClass: 'grid-row',
      attributes: {
        id: 'form-row'
      },
      inputChildren: {
        adrReappeared: {
          page: 0,
          elementType: 'typeahead',
          label: 'MEDICATIONS.V2.FORM.LABEL.ADR_REAPPEARED',
          wrapperClass: 'col-6',
          comboWrapperClass: 'col--no-margin',
          labelClass: 'col--no-margin',
          attributes: {
            name: 'adrReappeared',
            placeholder: 'MEDICATIONS.V2.FORM.PLACEHOLDER.FORM_ADMINISTERED_SELECT_ONE',
            class: 'INC-medications__administered-field'
          },
          options: adrReappearedOptions,
          useLegacyDropDownComponent:true
        }
      }
    },
    bnfClassificationRow : {
      page         : 0,
      globalSwitch : 'nrlsEnabled',
      gqlField     : 'bnfClassification',
      elementType  : 'multicolumn',
      labelFor     : 'administeredBnfClassification',
      wrapperClass : 'grid-row',
      attributes   : {
        id : 'bnfclassification-row'
      },
      inputChildren : {
        administeredBnfClassification : {
          page              : 0,
          elementType       : 'typeahead',
          label             : 'Drug administered or omitted BNF classification (1-15)',
          wrapperClass      : 'col-6',
          comboWrapperClass : 'col--no-margin',
          labelClass        : 'col--no-margin',
          attributes        : {
            name        : 'administeredBnfClassification',
            placeholder : 'MEDICATIONS.V2.FORM.PLACEHOLDER.FORM_ADMINISTERED_SELECT_ONE',
            class       : 'INC-medications__administered-field'
          },
          options    : bnfClassifications,
          useLegacyDropDownComponent:true
        },
        intendedBnfClassification : {
          page              : 1,
          elementType       : 'typeahead',
          label             : 'Drug intended BNF classification (1-15)',
          wrapperClass      : 'col-6',
          comboWrapperClass : 'col--no-margin',
          labelClass        : 'col--no-margin',
          attributes        : {
            name        : 'intendedBnfClassification',
            placeholder : 'MEDICATIONS.V2.FORM.PLACEHOLDER.FORM_INTENDED_SELECT_ONE',
            class       : 'INC-medications__intended-field'
          },
          options    : bnfClassifications,
          useLegacyDropDownComponent:true
        }
      }
    },
    batchNumberRow : {
      page         : 0,
      globalSwitch : 'nrlsEnabled',
      gqlField     : 'batchNumber',
      elementType  : 'multicolumn',
      labelFor     : 'administeredBatchNumber',
      wrapperClass : 'grid-row',
      attributes   : {
        id : 'batchnumber-row'
      },
      inputChildren : {
        administeredBatchNumber : {
          page              : 0,
          elementType       : 'input',
          label             : 'Drug administered or omitted batch number',
          wrapperClass      : 'col-6',
          comboWrapperClass : 'col--no-margin',
          labelClass        : 'col--no-margin',
          attributes        : {
            name        : 'administeredBatchNumber',
            class       : 'INC-medications__administered-field'
          }
        },
        intendedBatchNumber : {
          page              : 1,
          elementType       : 'input',
          label             : 'Intended drug batch number',
          wrapperClass      : 'col-6',
          comboWrapperClass : 'col--no-margin',
          labelClass        : 'col--no-margin',
          attributes        : {
            name        : 'intendedBatchNumber',
            class       : 'INC-medications__intended-field'
          }
        }
      }
    },
    ethicsCommitteeNameReferenceRow: {
      page         : 0,
      globalSwitch : 'nrlsEnabled',
      gqlField     : 'ethicsCommitteeNameReference',
      elementType  : 'multicolumn',
      labelFor     : 'administeredEthicsCommitteeNameReference',
      wrapperClass : 'grid-row',
      attributes   : {
        id : 'ethicscommitteenamereference-row'
      },
      inputChildren : {
        administeredEthicsCommitteeNameReference : {
          page              : 0,
          elementType       : 'input',
          label             : 'Drug administered or omitted ethics committee name and reference',
          wrapperClass      : 'col-6',
          comboWrapperClass : 'col--no-margin',
          labelClass        : 'col--no-margin',
          attributes        : {
            name        : 'administeredEthicsCommitteeNameReference',
            class       : 'INC-medications__administered-field'
          }
        },
        intendedEthicsCommitteeNameReference : {
          page              : 1,
          elementType       : 'input',
          label             : 'Drug intended ethics committee name and reference',
          wrapperClass      : 'col-6',
          comboWrapperClass : 'col--no-margin',
          labelClass        : 'col--no-margin',
          attributes        : {
            name        : 'intendedEthicsCommitteeNameReference',
            class       : 'INC-medications__intended-field'
          }
        }
      }
    },
    clinicalTrialRow : {
      page         : 0,
      globalSwitch : 'nrlsEnabled',
      gqlField     : 'clinicalTrial',
      elementType  : 'multicolumn',
      labelFor     : 'administeredClinicalTrial',
      wrapperClass : 'grid-row',
      attributes   : {
        id : 'clinicaltrial-row'
      },
      inputChildren : {
        administeredClinicalTrial : {
          page              : 0,
          elementType       : 'typeahead',
          label             : 'Is the drug administered or omitted under clinical trial?',
          wrapperClass      : 'col-6',
          comboWrapperClass : 'col--no-margin',
          labelClass        : 'col--no-margin',
          attributes        : {
            name        : 'administeredClinicalTrial',
            placeholder : 'MEDICATIONS.V2.FORM.PLACEHOLDER.FORM_ADMINISTERED_SELECT_ONE',
            class       : 'INC-medications__administered-field'
          },
          options    : yesNoUnknownOptions,
          useLegacyDropDownComponent:true
        },
        intendedClinicalTrial : {
          page              : 1,
          elementType       : 'typeahead',
          label             : 'Is the drug intended under clinical trial?',
          wrapperClass      : 'col-6',
          comboWrapperClass : 'col--no-margin',
          labelClass        : 'col--no-margin',
          attributes        : {
            name        : 'intendedClinicalTrial',
            placeholder : 'MEDICATIONS.V2.FORM.PLACEHOLDER.FORM_INTENDED_SELECT_ONE',
            class       : 'INC-medications__intended-field'
          },
          options    : yesNoUnknownOptions,
          useLegacyDropDownComponent:true
        }
      }
    },
    manufacturedSpecialRow : {
      page         : 0,
      globalSwitch : 'nrlsEnabled',
      gqlField     : 'manufacturedSpecial',
      elementType  : 'multicolumn',
      labelFor     : 'administeredManufacturedSpecial',
      wrapperClass : 'grid-row',
      attributes   : {
        id : 'manufacturedspecial-row'
      },
      inputChildren : {
        administeredManufacturedSpecial : {
          page              : 0,
          elementType       : 'typeahead',
          label             : 'Is the drug administered or omitted a manufactured special?',
          wrapperClass      : 'col-6',
          comboWrapperClass : 'col--no-margin',
          labelClass        : 'col--no-margin',
          attributes        : {
            name        : 'administeredManufacturedSpecial',
            placeholder : 'MEDICATIONS.V2.FORM.PLACEHOLDER.FORM_ADMINISTERED_SELECT_ONE',
            class       : 'INC-medications__administered-field'
          },
          options    : yesNoUnknownOptions,
          useLegacyDropDownComponent:true
        },
        intendedManufacturedSpecial : {
          page              : 1,
          elementType       : 'typeahead',
          label             : 'Is the drug intended a manufactured special?',
          wrapperClass      : 'col-6',
          comboWrapperClass : 'col--no-margin',
          labelClass        : 'col--no-margin',
          attributes        : {
            name        : 'intendedManufacturedSpecial',
            placeholder : 'MEDICATIONS.V2.FORM.PLACEHOLDER.FORM_INTENDED_SELECT_ONE',
            class       : 'INC-medications__intended-field'
          },
          options    : yesNoUnknownOptions,
          useLegacyDropDownComponent:true
        }
      }
    },
    parallelImport : {
      page         : 0,
      globalSwitch : 'nrlsEnabled',
      gqlField     : 'parallelImport',
      elementType  : 'multicolumn',
      labelFor     : 'administeredParallelImport',
      wrapperClass : 'grid-row',
      attributes   : {
        id : 'parallelimport-row'
      },
      inputChildren : {
        administeredParallelImport : {
          page              : 0,
          elementType       : 'typeahead',
          label             : 'Is the drug administered or omitted a parallel import?',
          wrapperClass      : 'col-6',
          comboWrapperClass : 'col--no-margin',
          labelClass        : 'col--no-margin',
          attributes        : {
            name        : 'administeredParallelImport',
            placeholder : 'MEDICATIONS.V2.FORM.PLACEHOLDER.FORM_ADMINISTERED_SELECT_ONE',
            class       : 'INC-medications__administered-field'
          },
          options    : yesNoUnknownOptions,
          useLegacyDropDownComponent:true
        },
        intendedParallelImport : {
          page              : 1,
          elementType       : 'typeahead',
          label             : 'Is the drug intended a parallel import?',
          wrapperClass      : 'col-6',
          comboWrapperClass : 'col--no-margin',
          labelClass        : 'col--no-margin',
          attributes        : {
            name        : 'intendedParallelImport',
            placeholder : 'MEDICATIONS.V2.FORM.PLACEHOLDER.FORM_INTENDED_SELECT_ONE',
            class       : 'INC-medications__intended-field'
          },
          options    : yesNoUnknownOptions,
          useLegacyDropDownComponent:true
        }
      }
    },
    stageErrorOccurredRow : {
      elementType  : 'multicolumn',
      wrapperClass : 'grid-row',
      inputChildren : {
        stageErrorOccurred : {
          page              : 0,
          elementType       : 'typeahead',
          label             : 'MEDICATIONS.V2.FORM.LABEL.STAGE_ERROR_OCCURED',
          wrapperClass      : 'col-6',
          comboWrapperClass : 'col--no-margin',
          labelClass        : 'col--no-margin',
          attributes        : {
            name        : 'stageErrorOccurred',
            placeholder : 'MEDICATIONS.V2.FORM.PLACEHOLDER.SELECT_ONE',
            class       : ['INC-medications__administered-field']
          },
          options    : stageErrorOccurred,
          validation : {
            required : !optionalField
          },
          useLegacyDropDownComponent: true
        }
      }
    },
    typeOfErrorRow : {
      elementType  : 'multicolumn',
      wrapperClass : 'grid-row',
      inputChildren : {
        typeOfError : {
          page              : 0,
          elementType       : 'typeahead',
          label             : 'MEDICATIONS.V2.FORM.LABEL.ERROR_TYPE',
          wrapperClass      : 'col-6',
          comboWrapperClass : 'col--no-margin',
          labelClass        : 'col--no-margin',
          attributes        : {
            name        : 'typeOfError',
            placeholder : 'MEDICATIONS.V2.FORM.PLACEHOLDER.SELECT_ONE',
            class       : ['INC-medications__administered-field'],
          },
          options    : typeOfError,
          validation : {
            required : !optionalField
          },
          useLegacyDropDownComponent: true
        },
      },
    },
    notes : {
      page         : 0,
      label        : 'MEDICATIONS.V2.FORM.LABEL.NOTES',
      elementType  : 'textarea',
      wrapperClass : 'grid-row',
      labelClass   : 'col-6',
      attributes   : {
        name  : 'notes',
        class : ['col-6','INC-medications__administered-field']
      }
    },
    importantFactorsRow : {
      elementType  : 'multicolumn',
      wrapperClass : 'grid-row',
      inputChildren : {
        importantFactors : {
          page              : 0,
          elementType       : 'typeahead',
          label             : 'MEDICATIONS.V2.FORM.LABEL.OTHER_IMPORTANT_FACTORS',
          wrapperClass      : 'col-6',
          comboWrapperClass : 'col--no-margin',
          labelClass        : 'col--no-margin',
          attributes        : {
            name        : 'importantFactors',
            placeholder : 'MEDICATIONS.V2.FORM.PLACEHOLDER.SELECT_ONE',
            class       : ['INC-medications__administered-field']
          },
          options    : importantFactors,
          validation : {
            required : !optionalField
          },
          useLegacyDropDownComponent: true
        },
      },
    },
    dateFirstUsedRow : {
      globalSwitch : 'vanessasLawEnabled',
      page         : 0,
      label        : 'MEDICATIONS.V2.FORM.LABEL.DATE_FIRST_USED',
      elementType  : 'date',
      wrapperClass : 'grid-row',
      labelClass   : 'col-6',
      attributes   : {
        name         : 'dateFirstUsed',
        class        : ['col-6','INC-medications__administered-field'],
        placeholder  : 'MEDICATIONS.V2.FORM.PLACEHOLDER.DATE_FIRST_USED',
        autocomplete : 'off'
      },
      dateFormat   : data.globalDateFormat
    },
    dateLastUsedRow : {
      globalSwitch: 'vanessasLawEnabled',
      page: 0,
      elementType: 'multicolumn',
      labelFor: 'administeredAdministrationForm',
      wrapperClass: 'grid-row',
      attributes: {
        id: 'form-row'
      },
      inputChildren: {
        productExpiryDate: {
          page: 0,
          elementType: 'date',
          label: 'MEDICATIONS.V2.FORM.LABEL.DATE_LAST_USED',
          wrapperClass: 'col-6',
          attributes: {
            name: 'dateLastUsed',
            placeholder: 'MEDICATIONS.V2.FORM.PLACEHOLDER.DATE_LAST_USED',
            class: ['INC-medications__administered-field'],
            autocomplete: 'off',
          },
          dateFormat: () => globals.dateFormat,
          visibleCondition: {
            fieldName: 'actionTaken',
            values: [actionTaken.withdrawn],
          },
        }
      }
    },
    adrDateReactionStarted: {
      label       : 'MEDICATIONS.V2.FORM.LABEL.ADR_DATE_REACTION_STARTED',
      elementType : 'date',
      visibility  : false
    },
    adrDateReactionStopped: {
      label       : 'MEDICATIONS.V2.FORM.LABEL.ADR_DATE_REACTION_STOPPED',
      elementType : 'date',
      visibility  : false
    },
    frequencyWrong : {
      elementType : 'typeahead',
      label       : 'MEDICATIONS.V2.FORM.LABEL.FREQUENCY_WRONG',
      options     : frequencyWrong,
      visibility  : false,
      useLegacyDropDownComponent: true
    },
    drugReaction : {
      elementType  : 'select',
      label        : 'MEDICATIONS.V2.FORM.LABEL.DRUG_REACTION',
      attributes   : {
        multiple    : 'true'
      },
      options : drugReaction,
      visibility  : false
    },
    errorDetectedBy : {
      elementType : 'typeahead',
      label       : 'MEDICATIONS.V2.FORM.LABEL.ERROR_DETECTED_BY',
      options     : errorDetectedBy,
      visibility  : false,
      useLegacyDropDownComponent: true
    },
    errorCommittedBy : {
      label       : 'MEDICATIONS.V2.FORM.LABEL.ERROR_COMMITTED_BY',
      visibility  : false
    },
    didDrugReactionReappear : {
      elementType : 'typeahead',
      label       : 'MEDICATIONS.V2.FORM.LABEL.DID_DRUG_REACTION_REAPPEAR',
      options     : didDrugReactionReappear,
      visibility  : false,
      useLegacyDropDownComponent: true
    },
    adrOrganSystem : {
      elementType : 'select',
      label       : 'MEDICATIONS.V2.FORM.LABEL.ADR_ORGAN_SYSTEM',
      options     : adrOrganSystem,
      visibility  : false,
      attributes  : {
        multiple    : 'true'
      },
    },
    naranjoTotalScore : {
      elementType : 'typeahead',
      label       : 'MEDICATIONS.V2.FORM.LABEL.NARANJO_TOTAL_SCORE',
      options     : naranjoTotalScore,
      visibility  : false,
      useLegacyDropDownComponent: true
    },
    adrActionTaken : {
      elementType : 'select',
      label       : 'MEDICATIONS.V2.FORM.LABEL.ADR_ACTION_TAKEN',
      options     : adrActionTaken,
      visibility  : false,
      attributes  : {
        multiple    : 'true'
      },
    },
    answersId : {
      page        : 0,
      elementType : 'hidden',
      attributes  : {
        name  : 'answersId',
        value : data.answersId,
        donotclear : true
      }
    },
    adrId : {
      page        : 0,
      elementType : 'hidden',
      attributes  : {
        name  : 'adrId',
        value : data.adrId
      }
    },
    dataViewRecordIndex : {
      page        : 0,
      elementType : 'hidden',
      attributes  : {
        name  : 'dataViewRecordIndex',
        donotclear : true
      }
    }
  };

  var visibleFields = getVisibleClientFields();

  function setVisibility(rowName) {
    var isVisible = visibleFields.indexOf(rowName) > -1;
    if (!isVisible && structure[rowName].inputChildren) {
      Object
        .entries(structure[rowName].inputChildren)
        .forEach(function (entry) {
          const childConfig = entry[1];
          if (childConfig.attributes) {
            childConfig.attributes.required = false;
          }
          if (typeof childConfig.validation === 'object') {
            childConfig.validation.required = false;
          }
        });
    }
    structure[rowName].visibility = isVisible;
    return rowName;
  }

  function assignDefaultDropdownProperties(fullStructure, key) {
    fullStructure[key].useLegacyDropDownComponent = true;
    if (fullStructure[key].attributes) {
      if (fullStructure[key].attributes.multiple) {
        // Default to a different placeholder (if one should exist).
      } else {
        fullStructure[key].attributes.placeholder = fullStructure[key].attributes.placeholder || 'MEDICATIONS.V2.FORM.PLACEHOLDER.SELECT_ONE';
      }
    }
    return fullStructure;
  }

  function assignDefaultDateProperties(fullStructure, key) {
    fullStructure[key].comboWrapperClass = fullStructure[key].comboWrapperClass || 'col-6';
    fullStructure[key].autocomplete = 'off';
    // fullStructure[key].attributes.placeholder = 'DEVICES.V2.FORM.PLACEHOLDER.EXPIRY_DATE_FORMAT'; // Todo: Find/implement meds date placeholder.
    fullStructure[key].dateFormat = fullStructure[key].dateFormat || function () {
      return globals.dateFormat;
    };
    return fullStructure;
  }

  function assignMandatoryValue(fieldConfig) {
    if (fieldConfig.validation && fieldConfig.validation.required) {
      fieldConfig.attributes.required = 'required';
    }

    return fieldConfig;
  }

  function traverseFieldConfigStructure(fieldConfig, key, callback) {
    callback(fieldConfig, key);
    Object
      .entries(fieldConfig.inputChildren || {})
      .forEach(entry => {
        traverseFieldConfigStructure(entry[1], entry[0], callback);
      });
  }

  // Function which assigns default values to the structural elements.
  function assignDefaultProperties(fullStructure, key) {
    fullStructure[key] = Object.assign({
      page         : 0,
      wrapperClass : 'grid-row',
      labelClass   : 'col-6'
    }, fullStructure[key]);

    fullStructure[key].attributes = Object.assign({
      name        : key,
      class       : ['col-6','INC-medications__administered-field']
    }, fullStructure[key].attributes || {});

    assignMandatoryValue(fullStructure[key]);

    traverseFieldConfigStructure(fullStructure[key], key, assignMandatoryValue);

    // Assign default properties according to element type.
    Object.entries({
      select: assignDefaultDropdownProperties,
      date: assignDefaultDateProperties
    }).forEach(function (entry) {
      if (fullStructure[key].elementType === entry[0]) {
        fullStructure = entry[1](fullStructure, key);
      }
    });

    return fullStructure;
  }

  // Applies default structural assignment function to structure.
  Object
    .keys(structure)
    .map(setVisibility)
    .reduce(assignDefaultProperties, structure);

  return structure;
};
